import {
  Button,
  Container,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import ImageCarousel from "../../components/Login/ImageCarousel";
import InputText from "../../components/InputText";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserAttributes, signIn } from "aws-amplify/auth";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { fetchAuthSession } from "aws-amplify/auth";
import { setAuthenticatedUser } from "../../redux/slices/user";
import { toast } from "react-toastify";
import { AUTHENTICATED } from "../../constants";
import { Eye } from "lucide-react";

const Login = () => {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const response = await signIn({
          username: values.email,
          password: values.password,
        });

        console.log(response, "after sign in");

        if (response.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE") {
          navigate("/verify-otp");
          return;
        }
        
        // Get the authenticated session
        const { tokens: session } = await fetchAuthSession();
        const attributes = await fetchUserAttributes();
        const groups = session.accessToken.payload["cognito:groups"] || [];
        
        // Save token details with expiry information
        localStorage.setItem("loggedInUserGroups", JSON.stringify(groups));
        localStorage.setItem("token", JSON.stringify(session));
        localStorage.setItem("attributes", JSON.stringify(attributes));
        
        // Store the time when we should refresh the token (5 min before expiry)
        const expiryTime = session.accessToken.payload.exp * 1000;
        const refreshTime = expiryTime - (5 * 60 * 1000);
        localStorage.setItem("tokenRefreshTime", refreshTime.toString());

        if (response.isSignedIn) {
          dispatch(
            setAuthenticatedUser({
              authState: AUTHENTICATED,
              role: groups[0],
              attributes,
            })
          );
          navigate("/");
        }
      } catch (error) {
        console.log(error);
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });
  
  return (
    <Container
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
          width: "100%",
          marginY: "auto",
          alignItems: "stretch",
          backgroundColor: "white",
          gap: 5,
        }}
      >
        <Stack
          sx={{
            backgroundColor: "#323232",
            borderRadius: "10px",
            gap: 4,
            justifyContent: "center",
            alignItems: "center",
            flexBasis: "50%",
            padding: "20px 50px",
          }}
        >
          <Box>
            <img
              src="/assets/DreamStreamLogo.svg"
              alt=""
              width={"153px"}
              height={65}
            />
            <Typography sx={{ color: "secondary.main", textAlign: "center" }}>
              Magic in motion
            </Typography>
          </Box>
          <Box flexBasis={"50%"} width={"100%"}>
            <ImageCarousel />
          </Box>
          <Typography textAlign={"center"} sx={{ color: "white" }}>
            Managing content made eaiser <br /> Create an account and start your
            journey today !
          </Typography>
        </Stack>

        <Stack
          sx={{
            gap: 4,
            flexBasis: "50%",
          }}
        >
          <Typography textAlign={"center"} variant="h4">
            Login
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <InputText
              label={"Email"}
              placeholder={"Enter email address"}
              name={"email"}
              formik={formik}
              id={"email"}
              value={formik.values.email}
            />

            <InputText
              label={"Password"}
              placeholder={"Enter password"}
              name={"password"}
              formik={formik}
              id={"password"}
              type={"password"}
              value={formik.values.password}
            />

            <LoadingButton
              loading={isLoading}
              fullWidth
              sx={{ my: 4 }}
              type="submit"
              variant="contained"
            >
              Login
            </LoadingButton>
            <Typography textAlign={"right"}>
              Don't have an account? Create one{" "}
              <span>
                <Link to={"/signup"}>Signup</Link>
              </span>
            </Typography>
          </form>
        </Stack>
      </Box>
    </Container>
  );
};

export default Login;